import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function AboutPage() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "神马视频",
    url: "https://www.shenmavideo.com",
    description: "神马视频提供91视频、91在线视频、97视频、51视频高清影视大全，免费在线观看，不缓冲流畅播放，电视剧电影一应俱全。",
    foundingDate: "2020",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      email: "contact@shenmavideo.com",
      availableLanguage: ["Chinese"],
    },
    sameAs: [
      "https://www.shenmavideo.com",
    ],
  };

  const aboutPageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于我们 - 神马视频",
    description: "了解神马视频的品牌故事、发展历程、用户口碑与联系方式。神马视频专注于提供91视频、97视频、51视频高清影视内容在线观看服务。",
    url: "https://www.shenmavideo.com/about",
    isPartOf: {
      "@type": "WebSite",
      name: "神马视频",
      url: "https://www.shenmavideo.com",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: "关于我们" },
            ]}
          />

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
                关于神马视频
              </h1>
              <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                神马视频成立于2020年，致力于为广大用户提供优质的在线视频观看体验。
                我们汇聚了91视频、91在线视频、97视频、51视频等海量高清影视资源，
                涵盖电视剧、电影、综艺、动漫、纪录片等全品类内容，让每一位用户都能找到自己喜欢的节目。
              </p>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 text-center font-heading">
                品牌故事
              </h2>
              <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                <div className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-lightbulb-line text-lg"></i>
                  </div>
                  <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                    我们的初心
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    在信息爆炸的时代，找到高质量的影视内容变得越来越难。神马视频的创立源于一个简单的想法——让每个人都能轻松找到并观看自己喜欢的视频内容。我们整合了91视频、97视频、51视频等多个优质视频平台的资源，为用户提供一站式观影服务。
                  </p>
                </div>
                <div className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-rocket-line text-lg"></i>
                  </div>
                  <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                    我们的成长
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    自2020年上线以来，神马视频已累计服务超过5000万用户，日均播放量突破1亿次。我们不断优化技术架构，提升播放流畅度，确保用户在任何网络环境下都能享受不缓冲的观影体验。91在线视频、97视频、51视频等分类持续丰富，满足不同用户的需求。
                  </p>
                </div>
                <div className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className="ri-shield-check-line text-lg"></i>
                  </div>
                  <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                    我们的承诺
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    我们承诺为用户提供安全、稳定、高清的在线视频服务。所有91视频资源均经过严格筛选，确保内容质量和播放体验。我们采用先进的视频编码技术和全球CDN加速节点，让每一位用户都能享受流畅的高清观影体验。
                  </p>
                </div>
                <div className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-heart-line text-lg"></i>
                  </div>
                  <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                    我们的愿景
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    成为中文互联网最受欢迎的视频导航平台，让"神马视频，想看就看"成为每一位用户的日常。我们持续拓展内容来源，优化用户体验，让91视频、97视频、51视频等优质内容触手可及。
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 text-center font-heading">
                用户口碑
              </h2>
              <p className="mt-2 text-sm text-foreground-500 text-center">
                来自真实用户的评价与反馈
              </p>
              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                <div className="p-5 bg-background-100 rounded-lg border border-background-200">
                  <div className="flex items-center gap-1 text-accent-500">
                    {[1,2,3,4,5].map((i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    "神马视频真的太方便了！我之前找91视频资源总是要翻来翻去，现在一个网站就搞定了。播放速度也很快，基本不用等缓冲，画质也很清晰。"
                  </p>
                  <div className="mt-4 flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-xs font-medium">
                      李
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-800">李先生</p>
                      <p className="text-xs text-foreground-400">资深剧迷</p>
                    </div>
                  </div>
                </div>
                <div className="p-5 bg-background-100 rounded-lg border border-background-200">
                  <div className="flex items-center gap-1 text-accent-500">
                    {[1,2,3,4,5].map((i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    "97视频和51视频的资源很全，更新也及时。我最喜欢的是分类做得很清晰，找电视剧和电影都很方便。推荐给身边好多朋友了！"
                  </p>
                  <div className="mt-4 flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 text-xs font-medium">
                      王
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-800">王女士</p>
                      <p className="text-xs text-foreground-400">追剧达人</p>
                    </div>
                  </div>
                </div>
                <div className="p-5 bg-background-100 rounded-lg border border-background-200">
                  <div className="flex items-center gap-1 text-accent-500">
                    {[1,2,3,4,5].map((i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    "作为纪录片爱好者，之前在91在线视频上找片源很费劲。神马视频的纪录片分类做得特别好，BBC和Discovery的片子很全，强烈推荐！"
                  </p>
                  <div className="mt-4 flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-600 text-xs font-medium">
                      张
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-800">张先生</p>
                      <p className="text-xs text-foreground-400">纪录片迷</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 text-center font-heading">
                联系我们
              </h2>
              <p className="mt-2 text-sm text-foreground-500 text-center">
                有任何问题或建议，欢迎随时与我们联系
              </p>

              <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="p-5 bg-background-50 rounded-lg border border-background-200 text-center">
                  <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <h3 className="mt-3 text-sm font-semibold text-foreground-900 font-heading">电子邮箱</h3>
                  <p className="mt-1 text-sm text-foreground-500">contact@shenmavideo.com</p>
                </div>
                <div className="p-5 bg-background-50 rounded-lg border border-background-200 text-center">
                  <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-customer-service-line text-lg"></i>
                  </div>
                  <h3 className="mt-3 text-sm font-semibold text-foreground-900 font-heading">客服热线</h3>
                  <p className="mt-1 text-sm text-foreground-500">400-888-8888</p>
                </div>
                <div className="p-5 bg-background-50 rounded-lg border border-background-200 text-center">
                  <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className="ri-time-line text-lg"></i>
                  </div>
                  <h3 className="mt-3 text-sm font-semibold text-foreground-900 font-heading">工作时间</h3>
                  <p className="mt-1 text-sm text-foreground-500">周一至周五 9:00-18:00</p>
                </div>
              </div>

              <div className="mt-8 p-5 md:p-6 bg-background-50 rounded-lg border border-background-200">
                <h3 className="text-base font-semibold text-foreground-900 font-heading mb-4">
                  发送消息
                </h3>
                <form
                  data-readdy-form
                  action="https://readdy.ai/api/form/d9n3ms0bdkpk99j7gg10"
                  method="POST"
                  className="space-y-4"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="name" className="block text-sm text-foreground-600 mb-1.5">
                        姓名
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="w-full px-3 py-2.5 bg-background-50 border border-background-200 rounded-md text-sm text-foreground-900 placeholder-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm text-foreground-600 mb-1.5">
                        邮箱
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="w-full px-3 py-2.5 bg-background-50 border border-background-200 rounded-md text-sm text-foreground-900 placeholder-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="subject" className="block text-sm text-foreground-600 mb-1.5">
                      主题
                    </label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      required
                      className="w-full px-3 py-2.5 bg-background-50 border border-background-200 rounded-md text-sm text-foreground-900 placeholder-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入消息主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm text-foreground-600 mb-1.5">
                      消息内容
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      maxLength={500}
                      required
                      className="w-full px-3 py-2.5 bg-background-50 border border-background-200 rounded-md text-sm text-foreground-900 placeholder-foreground-300 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                      placeholder="请输入您的消息（最多500字）"
                    ></textarea>
                  </div>
                  <div className="anti-spam-field">
                    <label htmlFor="phone_alt">备用电话</label>
                    <input
                      type="text"
                      id="phone_alt"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                </form>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}